import { Context as PosContext } from '@squareup/sq-addons-web-sdk';
import { v4 as uuidv4 } from 'uuid';

import { EnrollmentErrorCode, SquareLoyaltyApiError } from 'store/api/errors';

const CREATE_LOYALTY_ACCOUNT_API_ENDPOINT_PATH = '/v2/loyalty/accounts';

export async function createLoyaltyAccount(
  posContext: PosContext,
  phoneNumber: string
) {
  const squareDomain = posContext.configurations.environmentUrl;

  const response = await fetch(
    `${squareDomain}${CREATE_LOYALTY_ACCOUNT_API_ENDPOINT_PATH}`,
    {
      body: JSON.stringify({
        idempotency_key: uuidv4(),
        loyalty_account: {
          mapping: {
            phone_number: `+1${phoneNumber}`,
          },
          program_id: posContext.configurations.programId,
        },
      }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Square-Version': '2023-12-13',
      },
    }
  ).then((result) => result.json());

  if (response.errors?.length > 0) {
    const errorCode = response.errors[0].code;
    if (errorCode === 'BAD_REQUEST') {
      throw new SquareLoyaltyApiError({
        code: EnrollmentErrorCode.DUPLICATE_PHONE_NUMBER,
        message: response.detail,
      });
    } else if (errorCode === 'INVALID_PHONE_NUMBER') {
      throw new SquareLoyaltyApiError({
        code: EnrollmentErrorCode.INVALID_PHONE_NUMBER,
        message: response.detail,
      });
    } else {
      throw new SquareLoyaltyApiError({
        code: response.code,
        message:
          response.detail ||
          'Error calling the Square Loyalty Create Account API',
      });
    }
  }
}
